<template>
  <transition name="bounce">
    <b-container class="py-5 custom-container container">
      <b-breadcrumb
        :items="items"
        class="pl-0 pt-5 mt-5 bg-transparent"
      ></b-breadcrumb>
      <h2 class="font-weight-bold">Edit file</h2>
      <b-card class="mt-4">
        <div class="mx-auto p-lg-5 w-75">
          <h4 class="font-weight-bold mb-4">
            File Details
          </h4>
          <file-form :file="file" :new="false" v-if="file" />
        </div>
      </b-card>
    </b-container>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FileForm from '@/components/forms/FileForm'

export default {
  components: {
    FileForm
  },

  computed: {
    ...mapState({
      file: state => state.file.file
    }),
    items() {
      return [
        {
          text: this.file ? this.file.name : '',
          to: '/file/' + this.$route.params.id
        },
        { text: 'Edit' }
      ]
    }
  },

  methods: {
    ...mapActions({
      getFile: 'file/getFile'
    }),

    async fetchFile() {
      if (this.loading) return
      this.loading = true
      await this.getFile(this.$route.params.id)
      this.loading = false
    }
  },

  async created() {
    await this.fetchFile()
  }
}
</script>
